import { useSelector } from "react-redux";
import { userSelector } from "../../../../slices/user/userSlice";
import { UserUtils } from "../../../../app/data/user/userUtils";

export const useFactoringContext = () => {
  const userState = useSelector(userSelector);
  return {
    canManage: UserUtils.canAccessFinancePayments(userState.profile),
    terminalPrefix: userState.activeTerminal?.id ? `/${userState.activeTerminal.id}` : "",
  };
};
